import React, { useMemo } from 'react'
import { Layout, Button, Dropdown, Space, Select } from 'antd';
import { DownOutlined, MenuOutlined, GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { isSuperAdmin } from '../utils/roleUtils';

const LANGUAGE_VALUES = ['en', 'fr', 'de', 'es', 'it', 'nl', 'pt'];

function Header({ name, chooseProperty, propList, activePropertyName, role, isMobile, onMenuClick }) {
    const { t, i18n } = useTranslation();

    const LANGUAGES = useMemo(() =>
        LANGUAGE_VALUES.map(lang => ({
            value: lang,
            label: t(`language.codes.${lang}`)
        })),
        [t]
    );

    const handleMenuClick = (propertyID) => {
        chooseProperty(propertyID);
    };

    const propertyMenuItems = propList.map((property) => ({
        key: property.propertyID,
        label: property.companyName,
    }));

    return (
        <Layout.Header style={{
            background: 'linear-gradient(90deg, #5c7cfa 0%, #4c6ef5 100%)',
            boxShadow: '0 4px 20px rgba(92, 124, 250, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isMobile ? '0 12px' : '0 24px',
            height: 64,
            color: 'white'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1 }}>
                {isMobile && (
                    <Button
                        type="text"
                        icon={<MenuOutlined />}
                        onClick={onMenuClick}
                        style={{ color: 'white', fontSize: 16, flexShrink: 0 }}
                    />
                )}
                <span style={{
                    fontSize: isMobile ? '13px' : '18px',
                    fontWeight: 600,
                    color: 'white',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                    {name}
                </span>
            </div>
            <Space size={8}>
                <Space size={4} style={{ color: 'rgba(255,255,255,0.85)', fontSize: 12 }}>
                    <GlobalOutlined />
                    <Select
                        size="small"
                        value={i18n.language?.split('-')[0] || 'en'}
                        onChange={(lang) => i18n.changeLanguage(lang)}
                        options={LANGUAGES}
                        style={{ width: 70 }}
                        variant="borderless"
                        styles={{ popup: { root: { minWidth: 80 } } }}
                        popupMatchSelectWidth={false}
                    />
                </Space>
                {isSuperAdmin(role) && (
                    <Dropdown
                        menu={{
                            items: propertyMenuItems,
                            onClick: ({ key }) => handleMenuClick(key),
                        }}
                        trigger={['click']}
                    >
                        <Button type="primary" style={{ background: 'white', color: '#5c7cfa', border: 'none', fontWeight: 500 }}>
                            <Space size={4}>
                                {activePropertyName || t('header.chooseProperty')}
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                )}
            </Space>
        </Layout.Header>
    )
}

export default Header;
